const AppCOLORS = {
  scheduled: "#007BFF",   // blue
  completed: "#28A745",   // green
  active: "#28A745",      // active also green
  cancelled: "#DC3545",   // red
  missed: "#FF9800",      // orange
  inactive: "#9E9E9E",    // grey
};
const AppColorClass = {
  scheduled: "bg-blue-500",
  completed: "bg-green-500",
  active: "bg-green-500",
  cancelled: "bg-red-500",
  missed: "bg-orange-500",
  inactive: "bg-gray-500",

  // Event based
  session: "bg-green-500",
  followUp: "bg-yellow-500",
  payment: "bg-red-500",
  announcement: "bg-purple-500",
};



const eventColors = {
  active: 'text-green-800',
  completed: 'text-green-800',
  session: 'text-green-800',
  followUp: ' text-yellow-800',
  cancelled: ' text-red-800',
  missed: ' text-red-800',
  payment: ' text-red-800',
  announcement: 'text-purple-800',
  scheduled: 'text-blue-500'
};

const eventBgColors = {
  active: 'bg-green-100 text-green-800',
  completed: 'bg-green-100 text-green-800',
  session: 'bg-green-100 text-green-800',
  followUp: 'bg-yellow-100 text-yellow-800',
  cancelled: 'bg-red-100 text-red-800',
  missed: 'bg-orange-100 text-orange-800',
  payment: 'bg-red-100 text-red-800',
  announcement: 'bg-purple-100 text-purple-800',
  scheduled: 'bg-blue-100 text-blue-500'
};
export default AppCOLORS;

const getColor = (status, opacity = 1) => {
  const color = AppCOLORS[status] || "#000000";
  return `${color}${Math.round(opacity * 255).toString(16).padStart(2, "0")}`;
};
function getBgColorClass(status) {
  console.log(status);

  const hexClass = AppColorClass[status];

  if (!hexClass) return "bg-[#9E9E9E]";

  return hexClass;
}


export { getColor, getBgColorClass, eventBgColors, eventColors, AppColorClass };
